import { NodeRendererProps } from "@sanity/block-content-to-react";
import React, { ReactNode } from "react";
import checkmarkIcon from "../../assets/images/checkmark.svg";
import discIcon from "../../assets/images/circles.svg";
import { ElementClasses } from "./PortableText";

interface Props {
    sanityProps: React.PropsWithChildren<NodeRendererProps>;
    customElementClasses?: ElementClasses;
}

function extractContentAndSubUls(props: React.PropsWithChildren<NodeRendererProps>) {
    const
        content: ReactNode[] = [],
        uls: ReactNode[] = [];

    for (let i=0; i<props.node.children.length; ++i) {
        if (props.node.children[i]._type === "list") {
            uls.push(props.children?.[i]);
        }
        else {
            content.push(props.children?.[i]);
        }
    }

    return {
        content,
        uls
    };
}

const ListItemRenderer = ({customElementClasses, sanityProps}: Props) => {
    const {
        children,
        node
    } = sanityProps;

    const { content, uls } = extractContentAndSubUls(sanityProps);
    const liClassNames = customElementClasses?.li ?? "mb-3 last:mb-0 text-current text-xl";

    if (node.style === "checkmarkList") {
        return (
            <li className={`${liClassNames} font-bold flex`} key={node._key}>
                <div className="inline-block align-middle w-6 h-6 mr-4 rounded-full bg-brand-secondary-70 text-white mt-1 md:mt-0 min-w-6">
                    <div className="flex items-center justify-center h-full">
                        <svg
                            width={16}
                            height={16}
                        >
                            <use xlinkHref={checkmarkIcon.url}/>
                        </svg>
                    </div>
                </div>
                <div>
                    {content}
                    {uls}
                </div>
            </li>
        );
    }
    else if (node.style === "discList") {
        return (
            <li className={`${liClassNames} font-bold flex`} key={node._key}>
                <div
                    className="inline-block align-middle mr-3 rounded-full mt-2.5"
                >
                    <svg
                        width={8}
                        height={8}
                    >
                        <use xlinkHref={discIcon.url}/>
                    </svg>
                </div>
                <div>
                    {content}
                    {uls}
                </div>
            </li>
        );
    }

    return <li className={`list-disc ml-6 ${liClassNames}`}>{children}</li>;
};

export default ListItemRenderer;